module.exports = __webpack_public_path__ + "img/administrative.76a60011.png";